import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {AuthUser, UserFormData} from "../../types/user";
import {LeagueModelParams, LeagueResponse} from "../../types/league";
import {FixtureModelParams} from "../../types/fixture";
import {TeamModelParams, TeamResponse} from "../../types/team";
import {ApiSportsEndPointResponse} from "./types";

export const getTeam = async (client: AxiosInstance, teamId: number) =>
    responseHandler<ApiSportsEndPointResponse<TeamResponse>>(client.get(`/teams/${teamId}`))

export const getTeams = async (client: AxiosInstance, params?: Partial<TeamModelParams>) => {
    client.defaults.params = params
    return responseHandler<ApiSportsEndPointResponse<TeamResponse>>(client.get(`/teams`))
}